import { breakpoints } from '../global/breakpoints';
import { palette } from '../global/palette';
import { boxShadow } from '../global/shadows';
import { typography } from '../global/typography';
export const MuiPopover = {
    MuiPopover: {
        styleOverrides: {
            root: {
                ['& .MuiModal-backdrop']: {
                    backgroundColor: 'transparent',
                },
            },
            paper: {
                color: palette.grey[800],
                boxShadow: boxShadow.large,
                maxWidth: 400,
                maxHeight: 400,
                padding: '20px 24px',
                '& p': Object.assign({}, typography.body2),
                '& ul': {
                    padding: 0,
                },
                [breakpoints.down('sm')]: {
                    width: 'calc(100% - 32px)',
                },
            },
        },
    },
};
